import React, { Component, Fragment } from 'react';
import { connect, Provider } from 'react-redux';
import ConfigStock from '../Components/ConfigStock';
import { setArticleList } from '../Actions/ConfigStock.action';
class ConfigStockContainer extends Component {
    constructor(props) {
        super(props);

    }
    componentDidMount() {

        if (this.props.arrayarticleList.length > 0) {
            this.props.setArticleList(this.props.arrayarticleList);
        }
    }
    render() {

        return <ConfigStock {...this.props} />
    }

}
const mapStateToProps = (state) => {
    const { articleStock } = state;
    return {
        articleStock

    }
}
const mapDispatchToProps = dispatch => {
    return {
        setArticleList: (articleList) => dispatch(setArticleList(articleList))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigStockContainer);